export default __webpack_public_path__ + "static/ArminGrotesk-Regular-4c29d61a7e63c525c4290f1f4e1d1f4c.woff2";